<!-- <p>forbidden reusable component works!</p> -->
<div class="h-100 d-flex justify-content-center align-items-center">
  <mat-card
    appearance="outlined"
    style="border-radius: 12px; min-width: 800px; height: 650px; min-height: 400px"
    class="m-5 p-4 d-flex flex-column"
  >
    <div class="text-center">
      <img src="../../../assets/svg/icon_no-access.svg" width="60px" height="60px" />
    </div>
    <h2 class="forbidden-title" data-testid="forbidden-title-selector">
      You don't have access to {{ portal.name }}{{ submoduleName ? ' / ' + submoduleName : '' }}
    </h2>
    <p class="text-center" data-testid="forbidden-subtitle-selector">
      If you think this is a mistake contact any of the following System Administrators
    </p>
    <div
      class="flex-grow-1 my-3 d-flex flex-column justify-content-center align-items-center system-admin-panel v-slim-scrollbar mx-auto"
      style="overflow: auto; width: 600px"
      data-testid="forbidden-admins-table-selector"
    >
      @if (isLoadingSystemAdmins) {
        <div class="d-flex justify-content-center align-items-center">
          <mat-spinner [diameter]="36"></mat-spinner>
          <span class="udt-body-font ml-2">Loading System Administrators&hellip;</span>
        </div>
      }
      @if (!isLoadingSystemAdmins && systemAdmins.length === 0) {
        <div class="udt-body-font">There are no system admins registered</div>
      }
      @if (!isLoadingSystemAdmins && systemAdmins.length > 0) {
        <div class="h-100 w-100">
          <!-- <div style="position: absolute; height: 1px; background-color: black; top: 50px"></div> -->
          <table class="table admins-table">
            <thead class="sticky-top">
              <tr>
                <th>Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              @for (sysAdmin of systemAdmins; track sysAdmin.email; let i = $index) {
                <tr>
                  <td [attr.data-testid]="'forbidden-admin-fullname-' + i">{{ sysAdmin.fullName }}</td>
                  <td>
                    <a
                      href="mailto:{{ sysAdmin.email }}"
                      class="active-blue-color"
                      [attr.data-testid]="'forbidden-admin-email-' + i"
                      >{{ sysAdmin.email }}</a
                    >
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <button
        mat-flat-button
        color="primary"
        data-testid="forbidden-button-selector"
        class="my-2"
        (click)="returnToHomePage()"
      >
        Return to Home Page
      </button>
    </div>
  </mat-card>
</div>
